import * as React from "react";

interface Props {
  formattedTime: string
}

export const Time = React.memo((props: Props) => {
  return <div>{props.formattedTime + ' Uhr'}</div>
})
